module.exports = __webpack_public_path__ + "static/media/Sleeplessness.ae5d7f96.png";